// extracted by mini-css-extract-plugin
export default {"Container":"NetworkIssue_Container__-HDmD","HeadingText":"NetworkIssue_HeadingText__UbQh+","SubText":"NetworkIssue_SubText__cmAY-","Image":"NetworkIssue_Image__BVLHo"};